import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";

const LanguagePicker = () => {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const picked = localStorage.getItem("i18n_picked");
    const existingLang = localStorage.getItem("i18nextLng");
    // Skip if user already explicitly picked OR has a stored language preference
    if (picked || (existingLang && ["en", "es"].includes(existingLang.slice(0, 2)))) {
      return;
    }
    setOpen(true);
  }, []);

  const choose = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("i18n_picked", "1");
    localStorage.setItem("i18nextLng", lng);
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent data-testid="language-picker-dialog" className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle data-testid="language-picker-title">{t("common.chooseLanguage")}</DialogTitle>
          <DialogDescription>{t("common.chooseLanguageDesc")}</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3 py-4">
          <Button
            variant="outline"
            className="h-20 flex-col gap-2"
            onClick={() => choose("en")}
            data-testid="pick-language-en"
          >
            <span className="text-2xl">🇺🇸</span>
            <span className="font-semibold">English</span>
          </Button>
          <Button
            variant="outline"
            className="h-20 flex-col gap-2"
            onClick={() => choose("es")}
            data-testid="pick-language-es"
          >
            <span className="text-2xl">🇪🇸</span>
            <span className="font-semibold">Español</span>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LanguagePicker;
